





























import { Component, Emit, Prop } from 'vue-property-decorator'

import ClipboardCopyMixin from '../../../../../../../../../../../../logic/helpers/ClipboardCopyMixin'
import { UserInfo } from '../../../../../../../../../../../../models/getUserInfo/GetUserInfo'
import TargetCard from "../../../../../../../../../../../TargetCard/TargetCard.vue";
import { TargetCardInfo } from "../../../../../../../../../../../TargetCard/types";
import CustomEditor from '../../../../../../../../Editor/CustomEditor'

@Component({
  components: {
    TargetCard
  }
})
export default class NotifyUsersActionTable extends ClipboardCopyMixin {
  @Prop() users!: Array<UserInfo | { value: number, error: string }>

  @Prop() isLoading!: boolean

  @Prop() editor!: CustomEditor

  retestIsLoad = false

  currentPage = 1

  get formattedUsers(): Array<TargetCardInfo> {
    return this.users.map(u => {
      const successUser = 'info' in u

      return {
        type: 'user',
        error: u?.error ?? null,
        key: successUser ? u.info.id : u.value,
        title: successUser ? u.info.name : u.value.toString(),
        login: successUser ? u.info.login : null,
        id: successUser ? u.info.id : null
      }
    })
  }

  get paginatedUsers() {
    const itemsOnPage = 5
    const page = this.currentPage - 1

    return this.formattedUsers.slice(page * itemsOnPage, page * itemsOnPage + itemsOnPage)
  }

  retestUserHandler(value: string | number): void {
    this.retestIsLoad = true

    this.editor.getUsersInfo([ value ])
      .then(({ data }) => {
        if (data.length) {
          this.removeUser(value, false)
          this.addUser(data[0].info.id)
        }
      })
      .finally(() => this.retestIsLoad = false)
      .catch(() => this.retestIsLoad = false)
  }

  @Emit()
  addUser(id: number): number {
    return id
  }

  @Emit()
  removeUser(value: string | number, inFoundUsers: boolean): { value: string | number, inFoundUsers: boolean } {
    return { value, inFoundUsers }
  }
}
